import { cssObjectToString, type CssObject } from '@/app/appcharge/cssObjectToString';
import { Card } from '@/components/ui/card';
import { PortalBootResponse } from '@/lib/types';
import styled from 'styled-components';

export const DEFAULT_CARD_BACKGROUND_COLOR = 'rgba(0, 0, 0, 0.25)';
export const DEFAULT_CARD_BUTTON_COLOR = '#000';

const ROOT_SELECTOR = '.card-container';

export const scopeRootSelectors = (customCss?: CssObject): CssObject | undefined => {
  if (!customCss) return;

  return Object.fromEntries(
    Object.entries(customCss).map(([selector, declarations]) => [
      selector.startsWith(ROOT_SELECTOR) ? `&${selector}` : selector,
      declarations,
    ])
  );
};

export const StyledContentCard = styled(Card)<{
  $contentCard: PortalBootResponse['theme']['contentCard'] | undefined;
  $customCss?: CssObject;
  $thumbnailImage?: string;
}>`
  &.card-container {
    background-color: ${({ $contentCard }) =>
      $contentCard?.backgroundColor?.colorOne || DEFAULT_CARD_BACKGROUND_COLOR};
  }
  .card-image {
    ${({ $thumbnailImage }) =>
      $thumbnailImage && `background-image: url("${$thumbnailImage}");`}
  }
  .card-content {
    color: ${({ $contentCard }) => $contentCard?.textColor || 'inherit'};
  }
  .card-button {
    background-color: ${({ $contentCard }) =>
      $contentCard?.buttonColor?.colorOne || DEFAULT_CARD_BUTTON_COLOR};
    font-family: ${({ $contentCard }) => $contentCard?.cardButtonFont || 'inherit'};
  }

  ${({ $customCss }) => cssObjectToString(scopeRootSelectors($customCss))}
`;
